(() => {
  // The existing CartJS/Rivets cart expects Shopify.formatMoney, which this
  // theme does not currently supply. Preserve any installed implementation.
  window.Shopify = window.Shopify || {};
  if (typeof window.Shopify.formatMoney !== 'function') {
    window.Shopify.formatMoney = (cents, format) => {
      const template = format || window.CartJS?.settings.moneyFormat || '${{amount}}';
      const amount = Number(cents) / 100;
      return template.replace(/\{\{\s*(\w+)\s*\}\}/g, (_match, token) => {
        const decimals = token.includes('no_decimals') ? 0 : 2;
        const comma = token.includes('comma_separator');
        const space = token.includes('space_separator');
        const apostrophe = token.includes('apostrophe_separator');
        const thousands = space ? ' ' : apostrophe ? "'" : comma ? '.' : ',';
        const decimal = comma || space ? ',' : '.';
        const parts = (Number.isFinite(amount) ? amount : 0).toFixed(decimals).split('.');
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
        return parts.join(decimal);
      });
    };
  }
  if (customElements.get('pb-cart-recommendations')) return;
  class PBCartRecommendations extends HTMLElement {
    connectedCallback() {
      this.cards = [...this.querySelectorAll('[data-trigger-product]')];
      this.onClick = event => {
        const button = event.target.closest('[data-pb-rec-add]');
        if (button && this.contains(button)) this.add(button);
      };
      this.onCart = (_event, cart) => this.render(cart || window.CartJS?.cart);
      this.addEventListener('click', this.onClick);
      this.attempts = 0;
      this.connectCart();
    }
    connectCart() {
      if (!this.isConnected) return;
      if (window.jQuery && window.CartJS) {
        window.jQuery(document).on('cart.requestComplete', this.onCart);
        this.render(window.CartJS.cart);
      } else if (this.attempts++ < 40) {
        this.connectTimer = setTimeout(() => this.connectCart(), 250);
      }
    }
    disconnectedCallback() {
      clearTimeout(this.connectTimer);
      clearTimeout(this.statusTimer);
      this.removeEventListener('click', this.onClick);
      if (window.jQuery) window.jQuery(document).off('cart.requestComplete', this.onCart);
    }
    render(cart) {
      if (!cart || !Array.isArray(cart.items)) {
        this.hidden = true;
        return;
      }
      const productIds = new Set(cart.items.filter(i => i.quantity > 0).map(i => String(i.product_id)));
      const excluded = productIds.has(this.dataset.excludedProduct);
      let shown = false;
      this.cards.forEach(card => {
        const eligible = !shown && !excluded &&
          productIds.has(card.dataset.triggerProduct) &&
          !productIds.has(card.dataset.addonProduct);
        card.hidden = !eligible;
        card.querySelector('button').disabled = !!this.busy;
        if (eligible) shown = true;
      });
      this.hidden = !shown;
    }
    announce(message) {
      const status = document.getElementById(this.dataset.statusId);
      if (status) {
        status.textContent = message;
        clearTimeout(this.statusTimer);
        this.statusTimer = setTimeout(() => { status.textContent = ''; }, 6000);
      }
    }
    add(button) {
      if (this.busy || !window.CartJS || button.disabled) return;
      const card = button.closest('[data-variant-id]');
      if (!card || card.hidden) return;
      this.busy = true;
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      const finish = () => {
        this.busy = false;
        button.removeAttribute('aria-busy');
        this.render(window.CartJS.cart);
      };
      const fail = () => {
        finish();
        this.announce(this.dataset.errorLabel);
      };
      // Use the theme's own serialized cart queue and check fresh cart contents
      // before adding. Do not replace items, apply discounts or touch checkout.
      window.CartJS.getCart({
        success: cart => {
          const current = cart.items || [];
          if (current.some(i => String(i.product_id) === card.dataset.addonProduct)) {
            finish();
            return;
          }
          if (!current.some(i => String(i.product_id) === card.dataset.triggerProduct) ||
              current.some(i => String(i.product_id) === this.dataset.excludedProduct)) {
            finish();
            return;
          }
          window.CartJS.addItem(Number(card.dataset.variantId), 1, {}, {
            success: () => {
              this.announce(this.dataset.addedLabel);
              // CartJS refreshes its cart model and Rivets bindings after addItem.
              // A queued getCart also gives our component an authoritative view.
              window.CartJS.getCart({
                success: fresh => {
                  finish();
                  this.render(fresh);
                  if (document.activeElement === button && card.hidden) {
                    const next = this.querySelector('[data-trigger-product]:not([hidden]) button');
                    (next || this.closest('cart-slide')?.querySelector('.cart-slide__checkout-btn'))?.focus();
                  }
                },
                error: finish
              });
            },
            error: fail
          });
        },
        error: fail
      });
    }
  }
  customElements.define('pb-cart-recommendations', PBCartRecommendations);
})();
